"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var AuthProvider_1 = require("../api/v3/AuthProvider");
var common = __importStar(require("../Common"));
function userPassProvider(auth) {
    var providerRoute = 'providers/local-userpass';
    var loginRoute = "".concat(providerRoute, "/login");
    return {
        authenticate: function (_a) {
            var username = _a.username, password = _a.password;
            var fetchArgs = common.makeFetchArgs('POST', {
                body: JSON.stringify({ username: username, password: password }),
            });
            return fetch("".concat(auth.rootUrl, "/").concat(loginRoute), fetchArgs)
                .then(common.checkStatus)
                .then(function (response) { return response.json(); })
                .then(function (json) { return auth.set(json); });
        },
    };
}
function apiKeyProvider(auth) {
    var loginRoute = 'providers/api-key/login';
    return {
        authenticate: function (key) {
            var fetchArgs = common.makeFetchArgs('POST', {
                body: JSON.stringify({ key: key }),
            });
            return fetch("".concat(auth.rootUrl, "/").concat(loginRoute), fetchArgs)
                .then(common.checkStatus)
                .then(function (response) { return response.json(); })
                .then(function (json) { return auth.set(json); });
        },
    };
}
function mongodbCloudProvider(auth) {
    var loginRoute = 'providers/mongodb-cloud/login';
    return {
        authenticate: function (data) {
            var username = data.username, apiKey = data.apiKey, cors = data.cors, cookie = data.cookie;
            var options = {
                cookie: cookie || false,
                cors: cors || true,
            };
            var fetchArgs = common.makeFetchArgs('POST', {
                body: JSON.stringify({ username: username, apiKey: apiKey }),
            });
            fetchArgs.credentials = 'include';
            var url = "".concat(auth.rootUrl, "/").concat(loginRoute);
            if (options.cookie) {
                return fetch("".concat(url, "?cookie=true"), fetchArgs).then(common.checkStatus);
            }
            return fetch(url, fetchArgs)
                .then(common.checkStatus)
                .then(function (response) { return response.json(); })
                .then(function (json) { return auth.set(json); });
        },
    };
}
function createProviders(auth) {
    var _a;
    return _a = {},
        _a[AuthProvider_1.AuthProviderType.MongoDBCloud] = mongodbCloudProvider(auth),
        _a[AuthProvider_1.AuthProviderType.APIKey] = apiKeyProvider(auth),
        _a[AuthProvider_1.AuthProviderType.Userpass] = userPassProvider(auth),
        _a;
}
exports.default = createProviders;
//# sourceMappingURL=Providers.js.map